var _path, _rect, _line, _rect2, _line2, _rect3, _line3, _line4, _line5, _line6, _line7, _line8, _line9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "qrcode",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_296",
    "data-name": "Caminho 296",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2195",
    "data-name": "Ret\\xE2ngulo 2195",
    width: 6,
    height: 6,
    rx: 1,
    transform: "translate(4 4)",
    fill: "none",
    stroke: "#354d9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Linha_87",
    "data-name": "Linha 87",
    y2: 0.01,
    transform: "translate(7 17)",
    fill: "none",
    stroke: "#354d9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2196",
    "data-name": "Ret\\xE2ngulo 2196",
    width: 6,
    height: 6,
    rx: 1,
    transform: "translate(14 4)",
    fill: "none",
    stroke: "#354d9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Linha_88",
    "data-name": "Linha 88",
    y2: 0.01,
    transform: "translate(7 7)",
    fill: "none",
    stroke: "#354d9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2197",
    "data-name": "Ret\\xE2ngulo 2197",
    width: 6,
    height: 6,
    rx: 1,
    transform: "translate(4 14)",
    fill: "none",
    stroke: "#354d9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Linha_89",
    "data-name": "Linha 89",
    y2: 0.01,
    transform: "translate(17 7)",
    fill: "none",
    stroke: "#354d9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Linha_90",
    "data-name": "Linha 90",
    x2: 3,
    transform: "translate(14 14)",
    fill: "none",
    stroke: "#354d9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Linha_91",
    "data-name": "Linha 91",
    y2: 0.01,
    transform: "translate(20 14)",
    fill: "none",
    stroke: "#354d9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "Linha_92",
    "data-name": "Linha 92",
    y2: 3,
    transform: "translate(14 14)",
    fill: "none",
    stroke: "#354d9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "Linha_93",
    "data-name": "Linha 93",
    x2: 3,
    transform: "translate(14 20)",
    fill: "none",
    stroke: "#354d9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "Linha_94",
    "data-name": "Linha 94",
    x2: 3,
    transform: "translate(17 17)",
    fill: "none",
    stroke: "#354d9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    id: "Linha_95",
    "data-name": "Linha 95",
    y2: 3,
    transform: "translate(20 17)",
    fill: "none",
    stroke: "#354d9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeIcon);
export default __webpack_public_path__ + "static/media/qr-code-icon.05c32557a77d0311933750c9c5e429fa.svg";
export { ForwardRef as ReactComponent };